export const aboutStats = {
  foundedYear: 2020,
  totalUsers: '1000万+',
  totalWorks: '3000+',
  dailyActive: '85万+',
};

export const aboutFeatures = [
  {
    id: 'feat-1',
    title: '海量资源',
    desc: '收录超过3000部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑等多种题材，每日持续更新，满足不同读者的阅读喜好。',
    icon: 'ri-stack-line',
  },
  {
    id: 'feat-2',
    title: '极速更新',
    desc: '与韩国同步更新，专业翻译团队确保第一时间带来最新连载章节，让漫友不再错过任何精彩内容。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'feat-3',
    title: '优质体验',
    desc: '高清画质、流畅翻页、智能推荐系统，为漫友打造沉浸式的在线阅读体验，让阅读成为一种享受。',
    icon: 'ri-device-line',
  },
  {
    id: 'feat-4',
    title: '社区互动',
    desc: '百万漫友聚集地，评论、评分、推荐功能完善，在这里找到志同道合的读漫伙伴，一起分享阅读的乐趣。',
    icon: 'ri-group-line',
  },
];

export const aboutMediaReviews = [
  {
    id: 'media-1',
    text: '韩漫大全以其丰富的资源和优秀的用户体验，成为中文韩漫爱好者首选阅读平台之一，在内容更新速度和翻译质量方面表现出色。',
    source: '动漫资讯网',
    role: '媒体评测',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20news%20media%20logo%20style%20icon%2C%20simple%20geometric%20design%2C%20clean%20modern%20look%2C%20warm%20tone%2C%20minimalist%20graphic&width=120&height=120&seq=about-avatar-media&orientation=squarish',
  },
  {
    id: 'media-2',
    text: '更新速度快、画质清晰、分类齐全——这是韩漫大全给读者最直观的三个印象标签。平台界面设计简洁大方，阅读体验流畅。',
    source: '二次元观察',
    role: '行业媒体',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20media%20brand%20icon%20design%2C%20abstract%20geometric%20shape%2C%20clean%20professional%20look%2C%20warm%20coral%20tone%2C%20minimalist%20graphic&width=120&height=120&seq=about-avatar-media2&orientation=squarish',
  },
];

export const teamMembers = [
  { name: '金泰浩', role: '创始人 & CEO', desc: '十年漫画行业经验' },
  { name: '李恩珠', role: '内容总监', desc: '前韩国漫画平台编辑长' },
  { name: '朴志勋', role: '技术负责人', desc: '全栈工程师' },
  { name: '崔美妍', role: '社区运营', desc: '百万粉丝社群管理者' },
];

export const timelineEvents = [
  { year: '2020', title: '网站正式上线', desc: '韩漫大全1.0版本发布，收录500+部韩漫作品' },
  { year: '2021', title: '用户突破100万', desc: '注册用户数突破百万大关，开启社区功能' },
  { year: '2022', title: '收录作品超2000部', desc: '与多家韩国漫画平台达成合作，资源大幅扩充' },
  { year: '2023', title: '日活跃用户50万', desc: '成为中文地区最大的韩漫阅读平台之一' },
  { year: '2024', title: '品牌全面升级', desc: '全新UI设计、智能推荐系统上线' },
  { year: '2025', title: '用户突破1000万', desc: '累计注册用户突破千万，日活跃用户超85万' },
];